import React from 'react'
import { Route, Redirect } from 'react-router-dom'

import MenySide from '../meny/'

import './layout.css'

let year = (new Date()).getFullYear();

const Footer = () => <footer>
	<p style={{ color: '#2e2d30', textAlign: 'right' }}> NORKART AS &nbsp; &copy; {year}</p>
</footer>


const LayoutWrapper = (Layout) =>
	({ component, ...rest }) => {
		const bruker = window.sessionStorage.getItem('bruker')

		const renderer = bruker
			? matchProps => <Layout component={component} {...matchProps} {...rest} />
			: matchProps => <Redirect to={{
				pathname: '/',
				state: { from: matchProps.location }
			}} />

		return <Route {...rest} render={renderer} />
	}

const DefaultLayoutContent = ({ component: Component, ...rest }) =>
	<div >
		<MenySide />
		<div className="container main body-content ">
			<Component {...rest} />
		</div>
		<Footer />
	</div>

const FullscreenLayoutContent = ({ component: Component, ...rest }) =>
	<div >
		<MenySide />
		<div className="container main body-content">
			<Component {...rest} />
		</div>
		<Footer />
	</div>

export let DefaultLayout = LayoutWrapper(DefaultLayoutContent)
export let FullscreenLayout = LayoutWrapper(FullscreenLayoutContent)

export function LoginRoute({ component: Component, authed, loginInn, ...rest }) {
	return (
		<Route
			{...rest}
			render={(props) => authed === false
				? (
					<div>
						<Component {...props} loginInn={loginInn} authed={authed} />
						<Footer />
					</div>
				)
				: <Redirect to='/forside' />}
		/>
	)
}



// WEBPACK FOOTER //
// ./src/felles/layout.jsx